import LogRocket from 'logrocket';
import { isLogRocketEnabled } from 'src/analytics/logRocket';

export const logger = isLogRocketEnabled ? LogRocket : console;
